
export default {
  name: 'HospitalsDetailGraph',
  props: {
    data: Array,
    lg: {
      type: Boolean,
      default: false
    }
  }
}
